import angular from 'angular';

angular.module('folkeuni').factory('OrdersApi', function ($http) {
  var self = this;
  var apiBase = '/api/orders';

  self.getCurrentUsersOrder = function (rootId) {
      return $http({
          method: 'get',
          url: apiBase
      });
  };

  self.getOrderByIdAndGuid = function(id, guid){
    return $http({
        method: 'get',
        url: apiBase + "/" + id + "/" + guid
    });
  }

  return self;
});
